export default {
  emojiPickerButtonAriaLabel: 'Choose an emoji',
};
